/** Texto para comparar e buscar: sem acento, sem maiúscula, espaços únicos. */
export const normalizeText = (text: string) =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

/** Cada palavra da busca aparece em algum lugar do texto (ordem livre). */
export const matchesQuery = (
  query: string,
  ...fields: Array<string | undefined>
) => {
  const words = normalizeText(query).split(' ').filter(Boolean);
  if (!words.length) return true;
  const haystack = normalizeText(fields.filter(Boolean).join(' '));
  return words.every((word) => haystack.includes(word));
};
